var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.113,
    height: 17.113,
    transform: "translate(0.695801 0.695648)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.124 9.43853C17.124 8.85708 17.0718 8.29799 16.9749 7.76126H9.25195V10.9332H13.665C13.475 11.9582 12.8972 12.8266 12.0288 13.4081V15.4655H14.6789C16.2294 14.038 17.124 11.9358 17.124 9.43853Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25213 17.4521C11.4661 17.4521 13.3223 16.7178 14.679 15.4654L12.029 13.408C11.2947 13.9 10.3554 14.1907 9.25213 14.1907C7.11641 14.1907 5.30868 12.7482 4.66386 10.8101H1.92432V12.9346C3.27359 15.6145 6.04668 17.4521 9.25213 17.4521Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66397 10.8102C4.49997 10.3182 4.40679 9.79267 4.40679 9.25222C4.40679 8.71176 4.49997 8.18622 4.66397 7.69422V5.56967H1.92443C1.36906 6.67667 1.05225 7.92904 1.05225 9.25222C1.05225 10.5754 1.36906 11.8278 1.92443 12.9348L4.66397 10.8102Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25214 4.31353C10.456 4.31353 11.537 4.72726 12.3868 5.53981L14.7387 3.1879C13.3186 1.86472 11.4624 1.05217 9.25214 1.05217C6.04668 1.05217 3.27359 2.88972 1.92432 5.56962L4.66386 7.69417C5.30868 5.75599 7.11641 4.31353 9.25214 4.31353Z",
    fill: "#EA4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.7c4f01588ce83f4b8a0b0be2273ccbf2.svg";
export { ForwardRef as ReactComponent };